import React from 'react';
import { LPConfig } from '../types';
import { buildTrackedUrl } from '../utils/buildTrackedUrl';
import { trackLead } from '../pixel/metaPixel';
import { trackLeadGTM } from '../pixel/gtm';

interface LandingPageProps {
  config: LPConfig;
  redirectUrl: string;
}

function LandingPage({ config, redirectUrl }: LandingPageProps) {
  const imageUrl = config.image
    ? config.image.startsWith('http') ? config.image : `${process.env.PUBLIC_URL}/brands/${config.image}`
    : undefined;

  return (
    <div className="container">
      <header className="header">
        <h1>{config.header}</h1>
      </header>
      <main className="main-content" style={config.gradient ? { backgroundImage: config.gradient } : undefined}>
        <div className="vip-group-title">
          <p>{config.title}</p>
          <p>{config.title2}</p>
        </div>
        <div className="discount-text">{config.subtitle}</div>
        <div className="cta-container">
          {imageUrl && (
            <div className="icon-container">
              <img src={imageUrl} alt="Brand Logo" className="shopping-bag-icon" />
            </div>
          )}
          <a
            href={buildTrackedUrl(redirectUrl)}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button animated-fast animated tada"
            onClick={() => { trackLead(); trackLeadGTM(); }}
          >
            {config.ctaButton}
          </a>
          <div className="members-count">{config.ctaSubtitle}</div>
        </div>
      </main>
      <footer className="footer">{config.footer}</footer>
    </div>
  );
}

export default LandingPage;
